import input from '../../../../input';

const dark = (params) => input.borderColor.disabled.dark(params);

export default dark;
